import { render, staticRenderFns } from "./References.vue?vue&type=template&id=2cc5a3a2"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports